import React, { useEffect, useState, useRef, useCallback } from 'react'
import { FormattedRelativeTime, FormattedMessage, useIntl } from 'react-intl'
import { selectUnit } from '@formatjs/intl-utils'
import messages from "./messages";
import { Button } from '@arnsbogroup/react-voicearchive'

const templates = {
  Example: (supplier) => `${supplier.firstname}, was awesome.`
}

const SupplierActivity = ({ supplier }) => {
  const logRef = useRef(null)
  const eventRef = useRef(null)
  const [event, setEvent] = useState('')
  const [events, setEvents] = useState([])
  const { formatMessage, formatDate } = useIntl()

  useEffect(() => {
    fetch(`/rest/v2/supplier/${supplier.uid}/activities?limit=50`)
      .then((response) => response.json())
      .then(({ data: events }) => setEvents(events.sort((a, b) => a.timestamp > b.timestamp ? 1 : -1)))
      .then(() => {
        if (logRef.current) {
          logRef.current.scrollTop = logRef.current.scrollHeight
        }
      })
      .catch((error) => window.alert(error))
  }, [supplier.uid])

  const onSend = useCallback(() => {
    if (!event.length) {
      return window.alert(formatMessage(messages.eventEmpty))
    }

    setEvent('')
    
    fetch(`/rest/v2/actionLogEntry/${supplier.uid}`, {
      method: 'POST',
      body: JSON.stringify({
        message: event,
      })
    })
      .then((response) => response.json())
      .then((nextEvent) => setEvents([...events, nextEvent]))
      .then(() => {
        if (logRef.current) {
          logRef.current.scrollTop = logRef.current.scrollHeight
        }
      })
      .catch((error) => window.alert(error))
  }, [event])


  return (
    <div className="w-full h-full flex flex-col overflow-hidden">
      <div className="grow overflow-y-scroll space-y-4 p-4" ref={logRef}>
        { events.map(({ id, body, timestamp, name }) => {
          const { value, unit } = selectUnit(timestamp * 1000);

          return (
            <div key={id} className="w-auto">
              <p
                tabIndex="0"
                className="shadow-sm cursor-pointer max-h-48 focus:max-h-full focus:outline-none focus:ring focus:border-primary-darker break-words overflow-hidden rounded bg-gray-300 text-gray-900 whitespace-pre-line px-4 py-2 text-sm"
              >
                { body }
              </p>


              <div className="text-xs mt-1 w-full text-right px-1 text-gray-500" title={formatDate(timestamp * 1000)}>
                <FormattedRelativeTime value={value} unit={unit} /> by { name || 'you' }
              </div>
            </div>
          )
        }) }
      </div>

      <div className="p-4">
        <div className="flex text-sm text-primary space-x-3 p-2">
          { Object.entries(templates).map(([name, func]) => (
            <Button
              variant="inline"
              size="sm"
              onClick={() => {
                setMessage(func(supplier))
                if (messageRef) {
                  messageRef.current.focus()
                }
              }}
            >
              { name }
            </Button>
          )) }
        </div>

        <textarea
          ref={eventRef}
          className="px-4 py-2 rounded-sm text-sm border border-gray-400 w-full"
          value={event}
          onFocus={() => eventRef.current.classList.add('h-40')}
          onBlur={() => eventRef.current && eventRef.current.classList.remove('h-40')}
          onChange={({ target: { value } }) => setEvent(value)}
          placeholder={`${formatMessage(messages.addActivity, { name: supplier.firstname })}...`}
        />
        
        <Button
          size="sm"
          variant={event.length ? 'solid' : 'outline'}
          className="w-full"
          disabled={!event.length}
          onClick={onSend}
          title={formatMessage(messages.submit)}
        >
          <FormattedMessage {...messages.submit}/>
        </Button>
      </div>
    </div>
  )
}

export default SupplierActivity
